module.exports = __webpack_public_path__ + "img/2.10ee60e5.jpg";